module.exports = __webpack_public_path__ + "static/img/logic.35ec6da1.svg";